import * as React from 'react'
import BaseIcon from 'react-icon-base'

const NotificationIconOutline = props => (
  <BaseIcon width="20" height="24" viewBox="0 0 20 24" {...props}>
    <g stroke="#6E8B96" strokeWidth="1.35" fill="none" fillRule="evenodd">
      <path d="M18.8 19.475v-1.089l-2.263-2.232v-5.5c0-1.717-.44-3.205-1.32-4.463-.899-1.31-2.139-2.16-3.72-2.55v-.77A1.6 1.6 0 0 0 11 1.687 1.647 1.647 0 0 0 9.8 1.197c-.467 0-.862.163-1.186.491A1.623 1.623 0 0 0 8.13 2.87v.77c-1.598.39-2.847 1.232-3.745 2.525-.88 1.257-1.32 2.754-1.32 4.49v5.5L.8 18.385v1.09h18zM7.621 20.821a2.179 2.179 0 0 0 4.358 0" />
    </g>
  </BaseIcon>
)

export default NotificationIconOutline
